const { REACT_APP_CLOUDINARY_CLOUD_NAME } = process.env;

export const cloudinaryOptimiseParams = ['f_auto', 'fl_lossy', 'q_auto:good'];

const getWindowDpr = (): number => {
  const windowDpr = window !== undefined ? Math.min(window.devicePixelRatio, 2).toFixed(1) : '1.0';

  return parseFloat(windowDpr);
};

export const getCloudinaryUrl = (
  imageUrl: string,
  params: Array<string> = cloudinaryOptimiseParams,
  renderWidth?: number,
): string => {
  if (!REACT_APP_CLOUDINARY_CLOUD_NAME) return imageUrl;

  params.push(`dpr_${getWindowDpr()}`);

  if (renderWidth) {
    const index = params.findIndex((p) => p.startsWith('w_'));
    if (index !== -1) {
      params.splice(index, 1);
    }
    params.push(`w_${Math.min(Math.ceil(renderWidth / 300) * 300, 3000)}`);
  }

  const regex = new RegExp(`https?://res.cloudinary.com/${REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload/(.*)`);
  if (regex.test(imageUrl)) {
    const publicId = (imageUrl.match(regex) || [])[1];
    return `https://res.cloudinary.com/${REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload/${params.join(',')}/${publicId}`;
  }

  return `https://res.cloudinary.com/${REACT_APP_CLOUDINARY_CLOUD_NAME}/image/fetch/${params.join(',')}/${imageUrl}`;
};
